export enum EventResourceTypeEnum {
    TARGETING_LIST = 'TARGETING_LIST',
    TARGETING_SEARCH = 'TARGETING_SEARCH',
    ACCOUNT_RENEWAL = 'AccountRenewal'
}
